import type { ServerMetadata } from "@app/lib/actions/mcp_internal_actions/tool_definition";
import { generativeUiPartSchema } from "@app/types/assistant/generative_ui";

export const GENERATIVE_UI_SERVER_NAME = "generative_ui" as const;
export const GENERATIVE_UI_RENDER_TOOL_NAME = "render" as const;

export const GENERATIVE_UI_RENDER_SCHEMA = {
  part: generativeUiPartSchema.describe(
    "One complete version-1 generative UI part. `type` selects the variant: " +
      "metric_group, data_table, chart, threshold_control, insight, or drilldown_action. " +
      "Each variant has its own required fields. `actions` items are follow_up, download, " +
      "save_artifact, or create_dashboard."
  ),
};

export const GENERATIVE_UI_TOOLS_METADATA = [
  {
    name: GENERATIVE_UI_RENDER_TOOL_NAME,
    description:
      "Render one complete structured inline UI part for the user. Pass a single finished part " +
      "(metric_group, data_table, chart, threshold_control, insight, or drilldown_action). " +
      "Partial or invalid payloads are rejected and never shown. Do not use this for durable " +
      "reports, PDFs, or files; those go through file generation.",
    schema: GENERATIVE_UI_RENDER_SCHEMA,
    stake: "never_ask",
    displayLabels: {
      running: "Rendering UI",
      done: "Render UI",
    },
    toolCostCategory: "basic",
    freeUsage: true,
  },
] as const;

export const GENERATIVE_UI_SERVER = {
  serverInfo: {
    name: GENERATIVE_UI_SERVER_NAME,
    version: "1.0.0",
    description:
      "Render structured inline UI parts such as metrics, tables, charts, insights, and drill-downs.",
    icon: "ActionPieChartIcon" as const,
    authorization: null,
    documentationUrl: null,
  },
  tools: GENERATIVE_UI_TOOLS_METADATA,
} as const satisfies ServerMetadata;
